export default {
    MUNICIPAL: 1,
    LOCAL_ATENDIMENTO: 2,
}